import { useState } from 'react';
import { toast } from 'sonner';

import {
  enhancedApi,
  JurisdictionType,
  ReadPoliceDepartment,
  TimeZone,
  UpdatePoliceDepartment,
} from '@/services/api/generated/policeDepartmentsService';

import { DepartmentFormData } from './types';

export const useDepartmentForm = (department: ReadPoliceDepartment) => {
  const [updateDepartment, { isLoading }] =
    enhancedApi.usePoliceDepartmentsPartialUpdateMutation();

  const initialFormData: DepartmentFormData = {
    name: department.name || '',
    stateCode: department.state_code || '',
    stateName: department.state_name || '',
    description: department.description || '',
    aliases: department.aliases || [],
    doNotCall: department.do_not_call || false,
    jurisdictionType: department.jurisdiction_type || '',
    jurisdictionName: department.jurisdiction_name || '',
    timeZone: department.time_zone || '',
  };

  const [formData, setFormData] = useState<DepartmentFormData>(initialFormData);

  const resetForm = () => setFormData(initialFormData);

  const handleSave = async () => {
    if (!formData.name.trim()) {
      toast.error('Department name is required');
      return false;
    }

    try {
      const payload: UpdatePoliceDepartment = {
        name: formData.name.trim(),
        state_code: formData.stateCode.trim().toUpperCase() || null,
        state_name: formData.stateName.trim() || null,
        description: formData.description.trim() || null,
        aliases: formData.aliases.length > 0 ? formData.aliases : null,
        do_not_call: formData.doNotCall,
        jurisdiction_type:
          (formData.jurisdictionType as JurisdictionType) || null,
        jurisdiction_name: formData.jurisdictionName || null,
        time_zone: (formData.timeZone as TimeZone) || null,
      };

      await updateDepartment({
        id: department.id,
        patchedUpdatePoliceDepartment: payload,
      }).unwrap();

      toast.success('Department updated');
      return true;
    } catch (error) {
      toast.error('Failed to update department');
      return false;
    }
  };

  return {
    formData,
    setFormData,
    resetForm,
    handleSave,
    isLoading,
  };
};
